import React from 'react';
import { Col, Row, Tabs } from 'antd';
import GeneralSettings from './GeneralSettings';
import NotificationSettings from './NotificationSettings';
import './settings.less';
import Department from './Department';
import { useHistory } from 'react-router-dom';

export default function Settings() {
  const history = useHistory();
  const departmentTab = history?.location?.state?.departmentTab || false;
  const items = [
    {
      key: '1',
      label: <span>General Settings</span>,
      children: <GeneralSettings />,
    },
    {
      key: '2',
      label: <span>Department</span>,
      children: <Department />,
    },
    {
      key: '3',
      label: <span>Notification Settings</span>,
      children: <NotificationSettings />,
    },
  ];
  return (
    <div className="plr-0 pt-0">
      <Row justify="center user-management">
        <Col span={24}>
          <Tabs defaultActiveKey={departmentTab ? '2' : '1'} items={items} />
        </Col>
      </Row>
    </div>
  );
}

